import React from "react";
import cx from "classnames";
import "./styles.scss";
import { Button, FlexBox, Image } from "components";
import { FooterProps } from "./types";
import Logo from "assets/logo.svg";
import InstagramLogo from "assets/social logos/instagram.svg";
import LinkedInLogo from "assets/social logos/linkedin.svg";
import FacebookLogo from "assets/social logos/facebook.svg";
import TwitterLogo from "assets/social logos/twitter.svg";
import { ChangeHistory, EventManager, EventNames } from "utils";
import Routes from "Routes/paths";
import ROUTE_PATH from "Routes/paths";
const Footer: React.FC<FooterProps> = ({
  className,
  buttonText,
  buttonAction,
  buttonDisable,
  buttonVariant,
  firstButtonText,
  firstButtonAction,
  secondButtonText,
  secondButtonAction,
  text,
}) => {
  return (
    <div
      className={cx(
        "footer animated fadeInUp delay-03s bg-white pd-h-60 pd-v-60",
        className
      )}
    >
      <FlexBox justifyBetween alignCenter className="leading-div">
        <Image
          src={Logo}
          className="footer-logo"
          onClick={() => {
            EventManager.send(EventNames.EVENTS_NAME.WEBSITE.FOOTER.HOME_CLICK);
            ChangeHistory("push", ROUTE_PATH.SAMPLES.LANDING);
          }}
        />
        <FlexBox className="w-50 content" justifyBetween>
          <p
            className="font-medium fs-14"
            onClick={() => {
              EventManager.send(
                EventNames.EVENTS_NAME.WEBSITE.FOOTER.ABOUT_US_CLICK
              );
              ChangeHistory("push", Routes.GENERAL.ABOUT_US);
            }}
          >
            About Us
          </p>
          <p
            className="font-medium fs-14"
            onClick={() => {
              EventManager.send(
                EventNames.EVENTS_NAME.WEBSITE.FOOTER.INTEGRATION_CLICK
              );
              ChangeHistory("push", ROUTE_PATH.DOCS.HOME);
            }}
          >
            Integration
          </p>
          {/* <p className="font-medium fs-14">Blogs</p> */}
          <p
            className="font-medium fs-14"
            onClick={() => {
              EventManager.send(
                EventNames.EVENTS_NAME.WEBSITE.FOOTER.PRIVACY_CLICK
              );
              ChangeHistory("push", Routes.GENERAL.PRIVACY_POLICY);
            }}
          >
            Privacy Policy
          </p>
          <p
            className="font-medium fs-14"
            onClick={() => {
              EventManager.send(
                EventNames.EVENTS_NAME.WEBSITE.FOOTER.TNC_CLICK
              );
              ChangeHistory("push", Routes.GENERAL.TNC);
            }}
          >
            Terms & Conditions
          </p>
        </FlexBox>
        <FlexBox className="w-15 social-content" justifyBetween alignCenter>
          <Image
            src={InstagramLogo}
            className="w-15"
            onClick={() => {
              EventManager.send(
                EventNames.EVENTS_NAME.WEBSITE.FOOTER.SOCIAL_MEDIA_CLICK
                  .INSTAGRAM
              );
              ChangeHistory("blank", "https://www.instagram.com/otpless/");
            }}
          />
          <Image
            src={LinkedInLogo}
            className="w-15"
            onClick={() => {
              EventManager.send(
                EventNames.EVENTS_NAME.WEBSITE.FOOTER.SOCIAL_MEDIA_CLICK
                  .LINKEDIN
              );
              ChangeHistory(
                "blank",
                "https://www.linkedin.com/company/otpless/"
              );
            }}
          />
          <Image
            src={FacebookLogo}
            className="w-15"
            onClick={() => {
              EventManager.send(
                EventNames.EVENTS_NAME.WEBSITE.FOOTER.SOCIAL_MEDIA_CLICK
                  .FACEBOOK
              );
              ChangeHistory("blank", "https://www.facebook.com/hello.otpless");
            }}
          />
          <Image
            src={TwitterLogo}
            className="w-15"
            onClick={() => {
              EventManager.send(
                EventNames.EVENTS_NAME.WEBSITE.FOOTER.SOCIAL_MEDIA_CLICK.TWITTER
              );
              ChangeHistory("blank", "https://twitter.com/otpless/");
            }}
          />
        </FlexBox>
      </FlexBox>
      {/* {window.screen.width < 968 ? (
        <div>
          <FlexBox justifyBetween>
            <div className="w-50">
              <Image src={Logo} className="footer-logo" />
              <p className="mr-t-20">Integration</p>
              <p className="mr-v-20">Why OTPless</p>
              <p>Pricing</p>
            </div>
            <div className="w-50">
              <p className="font-heavy">About Us</p>
              <p className="mr-v-20">Better Security</p>
              <p className="mr-v-20">Delightful Experience</p>
              <p className="mr-v-20">Lower Drop-off</p>
              <p className="mr-v-20">Higher Conversion</p>
              <p className="mr-v-20">Easy Integration</p>
              <p className="mr-v-20">Automated Nudges</p>
            </div>
          </FlexBox>
          <FlexBox justifyBetween className="mr-t-40">
            <div className="w-50">
              <p className="font-heavy clr-theme">Documents</p>
              <p className="mr-v-20">Blog</p>
              <p className="mr-v-20">Articles</p>
              <p className="mr-v-20">Customer Stories</p>
              <p className="mr-v-20">Podcasts</p>
            </div>
            <div className="w-50">
              <p className="font-heavy clr-theme">Blogs</p>
              <p className="mr-v-20">Partners</p>
              <p className="mr-v-20">Careers</p>
              <p className="mr-v-20">Sales@OTPless.com</p>
              <p className="mr-v-20">Sitemap</p>
            </div>
          </FlexBox>
        </div>
      ) : (
        <FlexBox justifyEvenly>
          <div className="w-20">
            <Image src={Logo} className="footer-logo" />
            <p>Integration</p>
            <p className="mr-v-20">Why OTPless</p>
            <p>Pricing</p>
          </div>
          <div className="w-20">
            <p className="font-heavy clr-theme">Features</p>
            <p className="mr-v-20">Better Security</p>
            <p className="mr-v-20">Delightful Experience</p>
            <p className="mr-v-20">Lower Drop-off</p>
            <p className="mr-v-20">Higher Conversion</p>
            <p className="mr-v-20">Easy Integration</p>
            <p className="mr-v-20">Automated Nudges</p>
          </div>
          <div className="w-20">
            <p className="font-heavy clr-theme">Resoures</p>
            <p className="mr-v-20">Blog</p>
            <p className="mr-v-20">Articles</p>
            <p className="mr-v-20">Customer Stories</p>
            <p className="mr-v-20">Podcasts</p>
          </div>
          <div className="w-20">
            <p className="font-heavy clr-theme">Company</p>
            <p className="mr-v-20">Partners</p>
            <p className="mr-v-20">Careers</p>
            <p className="mr-v-20">Sales@OTPless.com</p>
            <p className="mr-v-20">Sitemap</p>
          </div>
        </FlexBox>
      )} */}
      <p className="mr-t-20 fs-14 clr-disabled last-line">
        © OTPless Solutions Private Limited
      </p>
    </div>
  );
};
export default Footer;
